module.exports = __webpack_public_path__ + "img/cupcake-4.a2b85154.svg";